import { render, staticRenderFns } from "./ContainerDocs.vue?vue&type=template&id=7ed3cda0&scoped=true&"
import script from "./ContainerDocs.vue?vue&type=script&lang=js&"
export * from "./ContainerDocs.vue?vue&type=script&lang=js&"
import style0 from "./ContainerDocs.vue?vue&type=style&index=0&id=7ed3cda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3cda0",
  null
  
)

export default component.exports